import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_LAST_WORKING_DAY_API} from '@app/reactQuery/apis/constants';

export const RQUseGetLastWorkingDayData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_last_working_day_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, employeeCode} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_LAST_WORKING_DAY_API,
        null,
        certificate,
        {employeeCode:employeeCode},
        signal,
      );
    },
    ...options,
  });
};
